import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { dsDtos } from '@vectronic/openApi-admin';
import { BeltInfoComponent } from '../../components/belt-info/belt-info.component';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-belt-dialog',
  templateUrl: './belt-dialog.component.html',
  imports: [CardComponent, BeltInfoComponent, MatDialogModule],
})
export class BeltDialogComponent {
  data: {
    belt: dsDtos.Belt;
    idDevice: number;
  } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<BeltDialogComponent>);
}
